import axiosInstance from "../axiosInstance";
import { API_URLS } from "../url";
import { GetCurrentUserResponse, UserProfile } from "../../types/userProfile";
import { normalizeApiError, BusinessError } from "../../utils/normalizeApiError";

export const getCurrentUserAPI = async (): Promise<UserProfile> => {
  try {
    const { data } = await axiosInstance.get<GetCurrentUserResponse>(
      API_URLS.GET_CURRENT_USER_DETAILS
    );

    if (data?.response?.status === false) {
      throw new BusinessError(data.response.message || "Failed to fetch user details");
    }

    return data.response;
  } catch (error: any) {
    if (error?.isBusinessError) {
      throw error;
    }
    throw normalizeApiError(error);
  }
};
